// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import ColorPickerScreenTemplate from '@front/templates/ColorPickerScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class ColorPickerScreen extends TerceraWindowBase {
    constructor() {
        super();
        this.lostFocusOnOutsideClick = true;
    }
    static ShowScreen(x, y, curColor, callBack) {
        if (isNullOrUndefined(curColor)) {
            return;
        }
        const a = new ColorPickerScreen();
        void a.set('xFromProps', x);
        void a.set('yFromProps', y);
        void a.set('colorFromProps', curColor);
        void a.set('onColorPicked', callBack);
        MainWindowManager.AddControl(a);
    }
    oncomplete() {
        super.oncomplete();
        this.setPopupCoordinates();
        this.Controls.cpControl.setColor(this.get('colorFromProps'));
        this.Controls.cpControl.onMouseDown.Subscribe(this.executeColorPick, this);
        this.setFocus();
    }
    lostFocus() {
        const controol = this.Controls.cpControl;
        if (!isNullOrUndefined(controol)) {
            if (controol.startValueA !== controol.valueA) {
                this.runCallBack();
            }
        }
        super.lostFocus();
        this.dispose();
    }
    runCallBack() {
        const newColor = this.Controls.cpControl.getColor();
        const callBack = this.get('onColorPicked');
        if (!isNullOrUndefined(callBack)) {
            callBack(newColor);
        }
    }
    executeColorPick() {
        this.Controls.cpControl.onMouseDown.UnSubscribe(this.executeColorPick, this);
        this.runCallBack();
        this.lostFocus();
    }
    dispose() {
        const onCloseCallback = this.get('onCloseColorPicker');
        if (!isNullOrUndefined(onCloseCallback)) {
            onCloseCallback();
        }
        super.dispose();
    }
    setPopupCoordinates() {
        const r = new Rectangle(this.get('xFromProps'), this.get('yFromProps'), this.get('width'), this.get('height'));
        const newLoc = ControlsUtils.CorrectPopupLocation(r);
        const parentLoc = this.get('parentLoc');
        if (!isNullOrUndefined(parentLoc)) {
            newLoc.newX -= parentLoc.X;
            newLoc.newY -= parentLoc.Y;
        }
        this.setBounds(newLoc.newX, newLoc.newY, r.Width, r.Height);
    }
}
TerceraWindowBase.extendWith(ColorPickerScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: false,
            showFooter: false,
            resizable: false,
            focused: true,
            onColorChanged: null,
            width: 300,
            height: 330,
            xFromProps: 0,
            yFromProps: 0,
            onColorPicked: null,
            onCloseColorPicker: null,
            colorFromProps: '',
            parentLoc: null
        };
    },
    partials: { bodyPartial: ColorPickerScreenTemplate }
});
